import { environment } from 'environments/environment';

const AJS_MODULE_NAME = 'schoolLinqApp';
const AUTHENTICATED_ENTRY_PATH = '/home';
const AJS_MOUNT_NODE = 'ajs-root';

const SOCKETS_URL = environment.API_URL;
const SOCKETS_HUBNAME = 'SLHub';

export { AJS_MOUNT_NODE, AUTHENTICATED_ENTRY_PATH, AJS_MODULE_NAME, SOCKETS_URL, SOCKETS_HUBNAME };
